module.exports = __webpack_public_path__ + "static/media/CTLA_3-216w.99567ee5.webp";